import { z } from 'zod';
import { DataOriginSchema } from './common';
import { LegalCitationSchema } from './legal';

export const ResearchModeSchema = z.enum(['quick', 'comprehensive', 'custom']);
export type ResearchMode = z.infer<typeof ResearchModeSchema>;

export const ReviewStatusSchema = z.enum([
  'ai_draft',
  'under_review',
  'approved_internal',
  'requires_reverification',
  'archived',
]);
export type ReviewStatus = z.infer<typeof ReviewStatusSchema>;

export const PropositionSchema = z.object({
  id: z.string(),
  text: z.string(),
  citationIds: z.array(z.string()),
  caveat: z.string().optional(),
});
export type Proposition = z.infer<typeof PropositionSchema>;

/** Canonical research answer (ADR-004 amendment 3). */
export const ResearchAnswerSchema = z.object({
  id: z.string(),
  dataOrigin: DataOriginSchema,
  mode: ResearchModeSchema,
  query: z.string(),
  /** `answered` has propositions; `not_found` means not found WITHIN THE SEARCHED SCOPE only. */
  outcome: z.enum(['answered', 'not_found']),
  summary: z.string(),
  propositions: z.array(PropositionSchema),
  citations: z.array(LegalCitationSchema),
  coverage: z.object({
    searchedCollections: z.array(z.string()),
    knownGaps: z.array(z.string()),
    cannotEstablish: z.array(z.string()),
  }),
  reviewStatus: ReviewStatusSchema,
  sourceSetSnapshotId: z.string(),
  createdAt: z.string(),
});
export type ResearchAnswer = z.infer<typeof ResearchAnswerSchema>;
